module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/live-components/src/components/LiveShow/LiveBar/img/liveshow/audio-close-8439fa.svg";